import axios from 'axios';
import cookie from '../cookieHelper/cookie'; // Assuming you have a cookie helper

export default function checkExistingUser(data) {
    const API_URL = process.env.REACT_APP_BASE_URL + '/api/v1/userByEmail/' + data;

    console.log("Inside the API call");
    console.log(API_URL);
    console.log(data);

    // Retrieve the authentication token from cookies
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);

    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };

    return (
        axios.get(API_URL, config)
        .then(res => {            
            // console.log('Response: ', res.data); 
            return res;
        })
        .catch(err => {
            // console.log('Error: ', err);
            return err;
        })
    );
}
